import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/setup/',
    // redirect: '/sys/',
    component:layout,
    children:[
		{name: '系统设置', path: 'system/setting', component: ()=>_import('setting')},
        {name: '个人设置', path: 'personal/setting', component: ()=>_import('personalSetting')},
		{name: '协议与规则', path: 'system/agreement', component: ()=>_import('agreement')},
		{name: '运费模板', path: 'system/freight', component: ()=>_import('freight')},
		// add route here
    ]
}